import React from "react";
import { Box, Typography, Stack, Grid, LinearProgress } from "@mui/material";
import { formatMoney } from "../../producer-dashboard/ProducerDashboardHelper";

type OperatorStat = { awaited: number; paid: number; percentage: number };
type Stats = { totalInvoices: number; globalAwaited: number; opStats: Record<string, OperatorStat> };

type PendingPayoutInvoicesKPIsProps = {
    stats: Stats;
    currency: string;
    hasMultipleOperators: boolean;
};

export const PendingPayoutInvoicesKPIs = ({ stats, currency, hasMultipleOperators }: PendingPayoutInvoicesKPIsProps) => {
    return (
        <Box sx={{ mb: 4, p: 3, bgcolor: '#f8fafc', borderRadius: 3, border: '1px solid #e2e8f0' }}>
            <Grid container spacing={4} alignItems="center">
                <Grid size={{ xs: 12, md: hasMultipleOperators ? 3 : 12 }} sx={{ borderRight: hasMultipleOperators ? { md: '1px solid #cbd5e1' } : 'none' }}>
                    <Stack spacing={2} direction={hasMultipleOperators ? "column" : "row"} justifyContent={hasMultipleOperators ? "flex-start" : "space-around"}>
                        <Box>
                            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 700, letterSpacing: 0.5 }}>TOTAL INVOICES</Typography>
                            <Typography variant="h5" sx={{ fontWeight: 800, color: '#0f172a' }}>{stats.totalInvoices}</Typography>
                        </Box>
                        <Box>
                            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 700, letterSpacing: 0.5 }}>GLOBAL AWAITED</Typography>
                            <Typography variant="h5" sx={{ fontWeight: 800, color: '#d32f2f' }}>{formatMoney(stats.globalAwaited, currency)}</Typography>
                        </Box>
                    </Stack>
                </Grid>

                {hasMultipleOperators && Object.keys(stats.opStats).length > 0 && (
                    <Grid size={{ xs: 12, md: 9 }}>
                        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 700, mb: 1.5, display: 'block', letterSpacing: 0.5 }}>
                            AWAITED BREAKDOWN BY OPERATOR
                        </Typography>
                        <Grid container columnSpacing={4} rowSpacing={2}>
                            {Object.entries(stats.opStats)
                                .sort(([, a], [, b]) => b.awaited - a.awaited)
                                .map(([opName, opData]) => (
                                <Grid size={{ xs: 12, sm: 6, md: 4 }} key={opName}>
                                    <Stack direction="row" justifyContent="space-between" alignItems="flex-end" sx={{ mb: 0.5 }}>
                                        <Typography variant="body2" sx={{ fontWeight: 800, color: '#0f172a' }}>{opName}</Typography>
                                        <Typography variant="caption" sx={{ fontWeight: 700, color: '#d32f2f' }}>
                                            {formatMoney(opData.awaited, currency)}
                                        </Typography>
                                    </Stack>
                                    <LinearProgress 
                                        variant="determinate" 
                                        value={opData.percentage} 
                                        sx={{ 
                                            height: 6, borderRadius: 3, 
                                            bgcolor: '#fee2e2', 
                                            '& .MuiLinearProgress-bar': { bgcolor: '#ef4444' } 
                                        }} 
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </Box>
    );
};